"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useMemo } from "react";
import useDmWavesList from "@/hooks/useDmWavesList";
import useNewDropCounter, { getNewestTimestamp } from "./useNewDropCounter";
import { ApiWave } from "@/generated/models/ApiWave";
import type { MinimalWave } from "./useEnhancedWavesList";
function useEnhancedDmWavesList(activeWaveId) {
  const $ = _c(15);
  const wavesData = useDmWavesList();
  const {
    newDropsCounts,
    resetAllWavesNewDropsCount
  } = useNewDropCounter(activeWaveId, wavesData.waves, wavesData.mainWavesRefetch);
  let t0;
  if ($[0] !== newDropsCounts) {
    t0 = wave => {
      const newDropsData = {
        count: newDropsCounts[wave.id]?.count ?? 0,
        latestDropTimestamp: getNewestTimestamp(newDropsCounts[wave.id]?.latestDropTimestamp, wave.metrics.latest_drop_timestamp ?? null)
      };
      return {
        id: wave.id,
        name: wave.name,
        type: wave.wave.type,
        picture: wave.picture,
        contributors: wave.contributors_overview.map(_temp),
        newDropsCount: newDropsData,
        isPinned: false
      };
    };
    $[0] = newDropsCounts;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const mapWaveToMinimalWave = t0;
  let t1;
  if ($[2] !== mapWaveToMinimalWave || $[3] !== wavesData.waves) {
    t1 = wavesData.waves.map(mapWaveToMinimalWave);
    $[2] = mapWaveToMinimalWave;
    $[3] = wavesData.waves;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const mappedWaves = t1;
  let t2;
  if ($[5] !== mappedWaves) {
    t2 = [...mappedWaves].sort(_temp2);
    $[5] = mappedWaves;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  const sortedWaves = t2;
  let t3;
  if ($[7] !== resetAllWavesNewDropsCount || $[8] !== sortedWaves || $[9] !== wavesData.fetchNextPage || $[10] !== wavesData.hasNextPage || $[11] !== wavesData.isFetching || $[12] !== wavesData.isFetchingNextPage || $[13] !== wavesData.refetchAllWaves) {
    t3 = {
      waves: sortedWaves,
      isFetching: wavesData.isFetching,
      isFetchingNextPage: wavesData.isFetchingNextPage,
      hasNextPage: wavesData.hasNextPage,
      fetchNextPage: wavesData.fetchNextPage,
      addPinnedWave: _temp3,
      removePinnedWave: _temp4,
      refetchAllWaves: wavesData.refetchAllWaves,
      resetAllWavesNewDropsCount
    };
    $[7] = resetAllWavesNewDropsCount;
    $[8] = sortedWaves;
    $[9] = wavesData.fetchNextPage;
    $[10] = wavesData.hasNextPage;
    $[11] = wavesData.isFetching;
    $[12] = wavesData.isFetchingNextPage;
    $[13] = wavesData.refetchAllWaves;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
}
function _temp4() {}
function _temp3() {}
function _temp2(a, b) {
  return (b.newDropsCount.latestDropTimestamp ?? 0) - (a.newDropsCount.latestDropTimestamp ?? 0);
}
function _temp(c) {
  return {
    pfp: c.contributor_pfp
  };
}
export default useEnhancedDmWavesList;